import { render } from "./Reset_Password.vue?vue&type=template&id=33af927c&scoped=true"
import script from "./Reset_Password.vue?vue&type=script&lang=js"
export * from "./Reset_Password.vue?vue&type=script&lang=js"

import "./Reset_Password.vue?vue&type=style&index=0&id=33af927c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33af927c"]])

export default __exports__